import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment, useMemo } from 'react';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import unescapedText from 'I18n/utils/unescapedText';
import Small from 'UIComponents/elements/Small';

const ResultsCount = ({
  filtersHeadingI18nKey,
  hasResults,
  offset,
  resultsLength,
  resultsTotal,
  searchValue,
  showAllCategoriesSearchResults
}) => {
  const {
    start,
    end,
    total
  } = useMemo(() => ({
    start: resultsTotal ? offset + 1 : 0,
    end: Math.min(offset + resultsLength, resultsTotal),
    total: Math.max(resultsTotal, resultsLength)
  }), [offset, resultsLength, resultsTotal]);

  if (!(hasResults || showAllCategoriesSearchResults)) {
    return null;
  }

  const renderedCount = /*#__PURE__*/_jsxs(Fragment, {
    children: [/*#__PURE__*/_jsx(FormattedMessage, {
      message: "appMarketplace.storefront.results.resultsPage.resultsCount",
      options: {
        start,
        end,
        total
      }
    }), ' ', searchValue && /*#__PURE__*/_jsx(FormattedHTMLMessage, {
      message: "appMarketplace.storefront.results.resultsPage.resultsCountSearchText",
      options: {
        searchValue,
        pageHeading: unescapedText(showAllCategoriesSearchResults ? 'appMarketplace.storefront.results.resultsPage.headingText.allCategories' : filtersHeadingI18nKey)
      }
    })]
  });

  if (searchValue && !hasResults) {
    return /*#__PURE__*/_jsxs(Fragment, {
      children: [renderedCount, /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx(Small, {
        "data-test-id": "results-count-search-title",
        children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
          message: "appMarketplace.storefront.results.resultsPage.noResultsEmptyState.searchTitle_jsx",
          elements: {
            b: 'b'
          },
          options: {
            searchValue,
            pageHeading: unescapedText(filtersHeadingI18nKey)
          }
        })
      })]
    });
  }

  return renderedCount;
};

export default ResultsCount;